// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class QuickLookController {
   $route: any
   $uibModal: any
   $uibModalInstance: any
   appState: any
   availability: any
   citationTrail: any
   configService: any
   dialogService: any
   documentService: any
   feed: any
   journalCoverageDetailsService: any
   localizationService: any
   quickLookService: any
   scope: any
   translationService: any
   quickLookConfig: any
   $timeout: any
   viewState: ViewStateService
   constructor(scope: any, $timout: any, translationService: TranslationService, $uibModalInstance: any, $uibModal: any, quickLookService: QuickLookService, documentService: DocumentService, configService: ConfigService, localizationService: LocalizationService, appState: AppStateService, feed: ResultsFeedService, $route: any, dialogService: DialogService, journalCoverageDetailsService: JournalCoverageDetailsService, citationTrail: CitationTrailService, viewState: ViewStateService, availability: any) {
      this.scope = scope
      this.$timeout = $timout
      this.translationService = translationService
      this.$uibModalInstance = $uibModalInstance
      this.$uibModal = $uibModal
      this.quickLookService = quickLookService
      this.documentService = documentService
      this.configService = configService
      this.quickLookConfig = this.configService.data.quickLook
      this.localizationService = localizationService
      this.appState = appState
      this.feed = feed
      this.$route = $route
      this.dialogService = dialogService
      this.journalCoverageDetailsService = journalCoverageDetailsService
      this.citationTrail = citationTrail
      this.availability = availability
      this.initialize()
      this.scope.quickLookLoading = false
      this.scope.i18n = this.translationService
      this.scope.closeQuickLook = this.closeQuickLook
      this.scope.isPrev = this.isPrev
      this.scope.isLast = this.isLast
      this.scope.isQuickLookLoading = this.isQuickLookLoading
      this.scope.isRTL = this.isRTL
      this.scope.getTotalResults = this.getTotalResults
      this.scope.getCurrentIndex = this.getCurrentIndex
      this.viewState = viewState


      this.setDocumentDependentAttributes()

      // Close quicklook when a link is clicked, expect for prev/next navigation buttons. 
      this.appState.on('apply', () => {
         if (!this.scope.quickLookLoading && !this.scope.isNavigating) {
            return this.closeQuickLook(null)
         }
      })
   }

   $onInit() {
      this.scope.isNavigating = false
      return this.$uibModalInstance.result
         .then(() => {
            this.focusResultIndex(this.scope.index)
            return this.viewState.subView = ''
         }).catch((err: any) => {
            console.warn(err)
            this.focusResultIndex(this.scope.index)
            return this.viewState.subView = ''
         })
   }

   initialize() {
      this.scope.rtaLoaded = { loaded: true }
      this.scope.detailsExpanded = {
         subjectKeywords: this.quickLookConfig.expandedItems.includes('subject_keywords'),
         subjects: this.quickLookConfig.expandedItems.includes('subjects'),
         author_syndetics: this.quickLookConfig.expandedItems.includes('syndetics'),
         reviews_syndetics: this.quickLookConfig.expandedItems.includes('syndetics'),
         summary_syndetics: this.quickLookConfig.expandedItems.includes('syndetics'),
         details: this.quickLookConfig.expandedItems.includes('record_details'),
         library_notes: this.quickLookConfig.expandedItems.includes('library_notes')
      }
      // content may not be available for a given syndetics sub-category. SyndeticsDirective changes loaded to true if content is found.
      this.scope.syndeticsLoaded = { authors: { loaded: false }, reviews: { loaded: false }, summary: { loaded: false } }
      this.scope.isRTL = this.localizationService.localization.isRTL
      this.scope.allDocumentsSummary = this.quickLookService.getAllDocumentsSummary(this.scope.feed.items)
      this.scope.totalResults = this.quickLookService.getTotalResults(this.scope.feed.items)
      if (this.scope.document.index != null) {
         this.scope.index = this.getCurrentIndex()
      } else {
         this.scope.index = 1
      }

      this.scope.leaveOpen = false
      this.scope.displayJournalCoverageRanges = this.configService.data.results.displayJournalCoverageRanges
   }

   isPrev() {
      return this.scope.index > 1
   }

   isLast() {
      return this.scope.index === (this.scope.totalResults)
   }

   findItemByIndex(index: number) {
      return this.scope.allDocumentsSummary.find((item: any) => item.document?.index === index)
   }

   isQuickLookLoading() {
      return this.scope.quickLookLoading
   }

   isRTL() {
      return this.localizationService.localization.isRTL
   }

   getTotalResults() {
      return this.scope.totalResults
   }

   getCurrentIndex() {
      return this.scope.document.index
   }

   focusResultIndex(idx: any) {
      const liElement = document.querySelector(`[data-aid="result-number-${idx}"]`)
      if (liElement) {
         liElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
   }

   clickPrev() {
      this.scope.isNavigating = true
      if (!this.isPrev() || this.scope.quickLookLoading) return
      const item = this.findItemByIndex(this.scope.index - 1)
      if (item && !item.hidden) {
         this.scope.index--
         this.scope.document = item.document
         this.setDocumentDependentAttributes()
      } else {
         this.scope.quickLookLoading = true
         this.feed.loadPrev()
            .then(() => {
               this.showAfterLoad(false)
            })
      }
   }

   clickNext() {
      this.scope.isNavigating = true
      if (this.isLast() || this.scope.quickLookLoading) return
      const item = this.findItemByIndex(this.scope.index + 1)
      if (item && !item.hidden) {
         this.scope.index++
         this.scope.document = item.document
         this.setDocumentDependentAttributes()
      } else {
         this.getNext()
      }
   }

   getNext() {
      this.scope.quickLookLoading = true
      this.feed.loadNext(true)
         .then(() => {
            this.showAfterLoad(true)
         }).catch((err: any) => {
            console.error("An error occured while closing quick look -> " + err)
            this.scope.quickLookLoading = false
         })
   }

   /**
    * Open proper result in quicklook after switching page
    */
   showAfterLoad(next: boolean, tryCount = 1) {
      this.initialize()
      const item = this.findItemByIndex(next ? this.scope.index + 1 : this.scope.index - 1)
      // retry mechanism so get the proper item to show in quicklook
      if (!item) {
         if (tryCount > 10) {
            console.error('Could not find quicklook item after 10 tries')
            this.scope.quickLookLoading = false
            return
         }
         this.$timeout(() => { this.showAfterLoad(next, tryCount + 1)}, 100)
      }
      if (next) {
         this.scope.index++
      } else {
         this.scope.index--
      }

      this.scope.document = item.document
      this.setDocumentDependentAttributes()
      this.scope.quickLookLoading = false
   }


   closeQuickLook($event: any) {
      this.scope.quickLookLoading = false
      this.dialogService.closeModalDialog($event)
      if ($event) {
         $event.stopPropagation()
      }
      return this.$uibModalInstance.dismiss('closebutton')
   }

   setDocumentDependentAttributes() {
      this.setConfigAttributes()
      this.scope.showDocumentGlanceability = this.documentService.showDocumentGlanceability
      this.scope.getDocumentGlancebilityIcon = this.documentService.getDocumentGlancebilityIcon
      this.scope.displayWarningGlanceability = this.documentService.displayWarningGlanceability
      this.scope.getWarningGlanceabilityPublications = this.documentService.getWarningGlanceabilityPublications
      this.scope.getWarningGlanceabilityNotices = this.documentService.getWarningGlanceabilityNotices
      this.scope.checkGlanceabilityEnablmentFromCustomizer = this.documentService.checkGlanceabilityEnablmentFromCustomizer
      this.scope.displaySecondaryPublicationsTypesSeparator = this.documentService.displaySecondaryPublicationsTypesSeparator
      this.scope.displaySecondaryNoticeTypesSeparator = this.documentService.displaySecondaryNoticeTypesSeparator
      this.scope.document.index = this.scope.document.index || (this.scope.index) // use scope.index as fallback if index attr is missing for doc
      this.scope.availabilityDocs = [this.scope.document].concat(this.scope.document.peer_documents || [])
      this.scope.authors = this.documentService.getAuthors(this.scope.document)
      this.scope.showVideoLink = this.documentService.showVideoLink(this.scope.document)
      if (this.scope.showVideoLink) { this.scope.videoLink = this.documentService.getVideoLink(this.scope.document) }
      this.scope.computedVals = this.documentService.getComputedValues(this.scope.document)
      this.scope.syndeticsIsbn = this.scope.document.isbn
      this.scope.showSyndeticsContent = this.quickLookService.showSyndeticsContent(this.scope.document)
      const resultsConfig = this.configService.data.results
      this.scope.displayPeerReviewIndicator = resultsConfig.displayPeerReviewIndicator && this.scope.document.is_peer_reviewed
      this.scope.displayOpenAccessIndicator = resultsConfig.displayOpenAccessIndicator && this.scope.document.is_open_access
      this.scope.addOpenAccessLink = resultsConfig.addOpenAccessLink && this.scope.document.open_access_link
      this.scope.document.journalCoverageSummary = this.journalCoverageDetailsService.getJournalCoverageSummary(this.scope.document)
      this.scope.showJournalCoverage = this.journalCoverageDetailsService.isJournalCoverageAvailable(this.scope.document) && this.scope.displayJournalCoverageRanges
      this.scope.showPublicNotes = this.quickLookService.showPublicNotes(this.scope.document)
      this.loadAvailability()
      return this.scope.displayCitationTrail = resultsConfig.displayCitationTrail && (this.citationTrail.hasCitedBy(this.scope.document) || this.citationTrail.hasCites(this.scope.document))
   }

   // documents opened outside the results feed (e.g. Research Assistant) are not covered by the feed's RTA batch load
   loadAvailability() {
      const docs = (this.scope.availabilityDocs || []).filter((doc: any) => {
         const docAvailability = this.availability.getAvailability(doc.availability_id)
         return !(docAvailability.availabilities || docAvailability.error)
      })
      // skip the request when none of the docs have an RTA-enabled availability id, to avoid firing an empty update
      if (this.availability.getAvailabilityIDs(docs).length) { this.availability.getRTA(docs) }
   }


   setConfigAttributes() {
      const resultsConfig = this.configService.data.results
      this.scope.displayUnpaywallPDFs = resultsConfig.displayUnpaywallPDFs
      this.scope.displayLinkResolver = resultsConfig.displayLinkResolver
      this.scope.displayPdfQuickLinks = resultsConfig.displayPdfQuickLinks
      this.scope.displayHtmlQuickLinks = resultsConfig.displayHtmlQuickLinks
      this.scope.maximumFullTextLinks = resultsConfig.maximumFullTextLinks
      this.scope.enableAdditionalFullTextLinks = resultsConfig.enableAdditionalFullTextLinks
      this.scope.displayMultipleFullTextLinks = (this.scope.maximumFullTextLinks > 1) && this.scope.enableAdditionalFullTextLinks
      this.scope.altmetrics = this.configService.data.altmetrics
      this.scope.showCallNums = this.quickLookService.showCallNums()
      this.scope.showDeweys = this.quickLookService.showDeweys()
      this.scope.displayLibraryNotes = this.quickLookService.displayLibraryNotes()
      return this.scope.syndeticsClient = this.quickLookService.syndeticsClient()
   }
}

QuickLookController.$inject = ["$scope", "$timeout", "translationService", "$uibModalInstance", "$uibModal", "quickLookService", "documentService", "configService", "localizationService", "appStateService", "resultsFeedService", "$route", "dialogService", "journalCoverageDetailsService", "citationTrailService", "viewStateService", "availabilityService"]

angular.module('summonApp.controllers')
   .controller('QuickLookCtrl', QuickLookController)
